<template>
  <div class="monitor_wrap">

      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span @click="routerIndex" class="router_link">报警处理</span><span class="arrow">></span><span>报警详情</span>
        </div>
        <div>
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
    <div class="fixedScorll" :style="{height:scrollHeight+'px'}">
        <div class="main clearfix">
          <div class="main_left" style="flex: 1">
            <div style="font-weight: bold;padding-bottom: 15px">基本信息</div>
            <div class="left_item_info">
              <p :style="{width:leftItemWidth+'px'}">监测点名称:<span>{{basicInfo.monitoringName}}</span> </p>
              <p>监测类型:<span>{{basicInfo.type}}</span></p>
            </div>
            <div class="left_item_info">
              <p :style="{width:leftItemWidth+'px'}">监测点编号:<span>{{basicInfo.monitoringCode}}</span></p>
              <p style="line-height: 1">管理人员:<el-tooltip class="item" effect="dark" :content="basicInfo.managePeople" placement="bottom-start" :disabled="tipClientWidth>=tipScrollWidth">
                  <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;position: relative;top:2px" :style="{width:(mangerWidth-65-60)+'px'}" @mouseover="isShowTooltip($event)" v-html="basicInfo.manageName">
                  </span>
                </el-tooltip>
              </p>
            </div>
            <div class="left_item_info">
              <p :style="{width:leftItemWidth+'px'}" style="line-height: 1">监测点地址:<el-tooltip class="item" effect="dark" :content="basicInfo.detailAddress" placement="bottom-start" :disabled="(leftItemWidth-55)>overflowText">
                  <span :style="{width:(leftItemWidth-85)+'px'}" class="hidden_address" @mouseover="changeText($event)">{{basicInfo.detailAddress}}</span>
                </el-tooltip>
              </p>
              <p>所在楼层:<span>{{basicInfo.floorNum}}</span></p>
            </div>
            <div class="left_item_info">
              <p :style="{width:leftItemWidth+'px'}"><span class="device_type">设备状态:</span>
                <span style="color: #4caf50" v-if="basicInfo.deviceStatus=='启用'">{{basicInfo.deviceStatus}}</span>
                <span style="color: #f55353" v-else>{{basicInfo.deviceStatus}}</span>
              </p>
              <p>启用状态:
                <span style="color: #4caf50" v-if="basicInfo.enabled=='启用'">{{basicInfo.enabled}}</span>
                <span style="color: #f55353" v-else>{{basicInfo.enabled}}</span>
              </p>
            </div>
            <div class="left_btn">
              <el-button type="primary" @click="warningSilence" v-show="false">告警消音</el-button>
            </div>
          </div>
          <div class="main_left main_right">
            <div style="font-weight: bold;padding-bottom: 10px">当前状态</div>
            <div class="clearfix">
              <div class="right_left_container">
                <div class="type_current">
                  <p>监测状态</p>
                  <p style="color:#4caf50;padding-top: 4px;font-size: 16px" v-if="basicInfo.runStatus=='正常'">{{basicInfo.runStatus}}</p>
                  <p style="color:#f55353;padding-top: 4px;font-size: 16px" v-else>{{basicInfo.runStatus}}</p>
                </div>
                <div class="type_current">
                  <p>通讯状态</p>
                  <p style="color: #4caf50;padding-top: 4px;font-size: 16px" v-if="basicInfo.connectStatus=='在线'">{{basicInfo.connectStatus}}</p>
                  <p style="color: #f55353;padding-top: 4px;font-size: 16px" v-else>{{basicInfo.connectStatus}}</p>
                </div>
              </div>
              <div class="right_left_container img_container">
                <img v-if="basicInfo.runStatus == '正常'" src="../../assets/img/zhengchang.jpg" alt="">
                <img v-else src="../../assets/img/gaojing.jpg" alt="">
              </div>
            </div>
            <div class="current_time">
              {{basicInfo.recordTime}}
            </div>
          </div>
        </div>
      <div class="table_info">
        <div class="table mainHead">
          <div class="route" style="cursor: pointer;">
            <span class="crumbs"></span>
            <span :class="{isActivClass:isActive}" @click="changeData(1)">{{selectName1}}</span>
            <span></span>
            <span :class="{isActivClass:!isActive}" @click="changeData(2)">{{selectName2}}</span>
          </div>
          <div>
            <el-button type="primary" @click="warningSet" v-if="isAuth('alarmManager:creatAlarmSheet')">报警处理</el-button>
          </div>
        </div>
        <div class="table_data" v-if="tableData.length!==0" v-show="!warningData&&isAuth('common:interface')" :style="{minHeight:tableHeight+'px'}">
          <el-table
            :data="tableData"
            @row-click="lookDetailData"
            border
            style="width: 100%">
            <el-table-column
              label="序号"
              fixed
              width="70">
              <template slot-scope="scope">
                <div>{{13*(page-1)+(scope.$index+1)}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="alarmDealCode"
              label="处理单编号"
              min-width="176">
            </el-table-column>
            <el-table-column
            v-if="basicInfo.type=='用传'"
              prop="monitoringName"
              label="报警项目"
              min-width="186">
            </el-table-column>
            <el-table-column
            v-else
              prop="problem"
              label="报警项目"
              min-width="186">
            </el-table-column>
            <el-table-column
              min-width="186"
              label="处理人员">
              <template slot-scope="scope">
                <div class="has_user" v-if="scope.row.dealPeople">
                  <el-tooltip class="item" effect="dark" :content="scope.row.dealPeople" placement="bottom-start" :disabled="clientText>overflowText1">
                    <span @mouseover="changeText1($event)">{{scope.row.dealPeople}}</span>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              min-width="78"
              label="处理状态">
              <template slot-scope="scope">
                <div v-if="scope.row.dealStatus==2">处理中</div>
                <div v-else-if="scope.row.dealStatus==3">审核中</div>
                <div v-else-if="scope.row.dealStatus==4">不通过</div>
                <div v-else-if="scope.row.dealStatus==5">审核完成</div>
                <div v-else-if="scope.row.dealStatus==6">严重上报中</div>
                <div v-else-if="scope.row.dealStatus==7">已协调资源</div>
                <div v-else-if="scope.row.dealStatus==8">退回,继续整改</div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="solveTime"
              min-width="176"
              label="排故时间">
            </el-table-column>
            <el-table-column
              prop="verifyTime"
              min-width="176"
              label="审核时间">
            </el-table-column>
          </el-table>
          <div class="page_control" v-if="total1>13">
            <el-pagination
              @current-change="handleCurrentChange1"
              :current-page.sync="page"
              background
              :page-size="13"
              layout="prev, pager, next, jumper"
              :total="total1">
            </el-pagination>
          </div>
        </div>
        <div class="no_data" v-else :style="{minHeight:tableHeight+'px'}" v-show="!warningData">
          <div>
            <img src="../../../static/img/Nodata.png" alt="">
            <p class="no_tip">暂无数据</p>
          </div>
        </div>
        <div class="table_data" v-if="warningTableData.length!==0" :style="{minHeight:tableHeight+'px'}" v-show="warningData">
          <!--电气-->
          <div v-show="showType1">
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="ia"
                min-width="100"
                label="A相电流(A)">
              </el-table-column>
              <el-table-column
                min-width="100"
                label="B相电流(A)">
                <template slot-scope="scope">
                  <div>{{scope.row.ib}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ic"
                min-width="100"
                label="C相电流(A)">
              </el-table-column> -->
              <el-table-column
                prop="temp1"
                min-width="100"
                label="温度1(℃)">
                                           <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp1" style="color: #f55353">{{scope.row.temp1}}</div>
                                                <div v-else>{{scope.row.temp1}}</div>
                                            </template>
              </el-table-column>
              <el-table-column
                prop="temp2"
                min-width="100"
                label="温度2(℃)">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp2" style="color: #f55353">{{scope.row.temp2}}</div>
                                                <div v-else>{{scope.row.temp2}}</div>
                                            </template>
              </el-table-column>
              <el-table-column
                prop="temp3"
                min-width="100"
                label="温度3(℃)">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp3" style="color: #f55353">{{scope.row.temp3}}</div>
                                                <div v-else>{{scope.row.temp3}}</div>
                                            </template>
              </el-table-column>
              <el-table-column
                prop="temp4"
                min-width="100"
                label="温度4(℃)">
                                             <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp4" style="color: #f55353">{{scope.row.temp4}}</div>
                                                <div v-else>{{scope.row.temp4}}</div>
                                            </template>
              </el-table-column>
              <el-table-column
                prop="rcv"
                min-width="130"
                label="剩余电流(mA)">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmRcv" style="color: #f55353">{{scope.row.rcv}}</div>
                                                <div v-else>{{scope.row.rcv}}</div>
                                            </template>
              </el-table-column>
                                 <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                min-width="180"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="100"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType2">
            <!--可燃气-->
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="220">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="220">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
                                 <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                min-width="318"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="220"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType3">
            <!--灭火瓶-->
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="146">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="146">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="146"
                label="气压值(MPa)">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1||scope.row.runStatus==2" style="color: #f55353">{{scope.row.rcv}}</div>
                  <div v-else>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="146"
                label="电池电量">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
              </el-table-column>
                                 <!-- <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0" style="color: #f55353">无</div>
                                          <div v-else-if="scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column> -->
              <el-table-column
                prop="recordTime"
                min-width="248"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="146"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType4">
            <!--水压-->
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="146">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="146">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="146"
                label="水压值(MPa)">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus ==1 ||scope.row.runStatus ==2" style="color: #f55353">{{scope.row.rcv}}</div>
                  <div v-else>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="146"
                label="电池电量">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
              </el-table-column>
                                 <!-- <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0" style="color: #f55353">无</div>
                                          <div v-else-if="scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column> -->
              <el-table-column
                prop="recordTime"
                min-width="248"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="146"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType5">
            <!--烟感-->
            <el-table
              :data="warningTableData"
              
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="120">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="120">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">
                    <span v-if="scope.row.rcv == 1 || scope.row.rcv == 111">烟雾告警</span>
                    <span v-else-if="scope.row.rcv == 963">防拆告警</span>
                    <span v-else-if="scope.row.rcv == 986">高温告警</span>
                  </div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
            <el-table-column label="环境温度（℃）" min-width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.exField1">{{scope.row.exField1}}</div>
                <div v-else>--</div>
              </template>
            </el-table-column>
              <el-table-column
                min-width="180"
                label="电池电量">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
              </el-table-column>
                                 <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                min-width="258"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="180"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType6">
            <!--液位-->
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="146">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="146">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="146"
                label="液位值(m)">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1||scope.row.runStatus==2" style="color: #f55353">{{scope.row.rcv}}</div>
                  <div v-else>{{scope.row.rcv}}</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="146"
                label="电池电量">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
              </el-table-column>
                                 <!-- <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0" style="color: #f55353">无</div>
                                          <div v-else-if="scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column> -->
              <el-table-column
                prop="recordTime"
                min-width="248"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="146"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType7">
            <!--水浸-->
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="设备状态"
                min-width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                  <div v-else>启用</div>
                </template>
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                min-width="180"
                label="电池电量">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
              </el-table-column>
                                 <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 || scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
              <el-table-column
                prop="recordTime"
                min-width="258"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="180"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-show="showType8">
            <!--用传-->
            <el-table
              :data="warningTableData"
              border
              @row-click="lookDetailData1"
              style="width: 100%">
              <el-table-column
                label="序号"
                fixed
                width="70">
                <template slot-scope="scope">
                  <div>{{13*(warningTableDataPage-1)+(scope.$index+1)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="channelNo"
                label="设备编号"
                min-width="180">
              </el-table-column>
              <el-table-column
                label="监测状态"
                min-width="180">
                <template slot-scope="scope">
                  <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                  <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                  <div v-else>正常</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="monitoringName"
                label="报警设备"
                min-width="258">
              </el-table-column>
                <el-table-column prop="location" label="报警地址" min-width="246" show-overflow-tooltip></el-table-column>
              <el-table-column
                prop="recordTime"
                min-width="158"
                label="记录时间">
              </el-table-column>
              <el-table-column
                min-width="180"
                label="处理状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.dealStatus==0">待处理</div>
                  <div v-else-if="scope.row.dealStatus==1" class="special_color">处理中</div>
                  <div v-else-if="scope.row.dealStatus==2">审核中</div>
                  <div v-else-if="scope.row.dealStatus==3">已结束</div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page_control" v-if="warningTableDataTotal>13">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="warningTableDataPage"
              :page-size="13"
              background
              layout="prev, pager, next, jumper"
              :total="warningTableDataTotal">
            </el-pagination>
          </div>
        </div>
        <div class="no_data" v-else :style="{minHeight:tableHeight+'px'}" v-show="warningData">
          <div>
            <img src="../../../static/img/Nodata.png" alt="">
            <p class="no_tip">暂无数据</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import  {ajaxFuncJson} from '../../api/ajax';
  export default {
    name:'warnDetail',
    components:{

    },
    data(){
      return{
        isActive:true,
        basicInfo:{},     //基础信息
        widthNum: '',   //中间区域自适应宽度
        widthCard: '', //计算卡片宽度
        widthText: '', //计算卡片文本宽度
        leftItemWidth:'',
        tableHeight:'',    //表格的高度
        total:0,
        monitorList:[],
        tableData: [],
        page:1,
        total1:0,  //处理表单分页总数
        warningData:false,
        selectName1:'处理表单',
        selectName2:'报警数据',
        warningTableData:[],
        warningTableDataTotal:0,
        warningTableDataPage:1,
        scrollHeight:'',
        detailId:'',  //详情id
        showType1:false,   //电气
        showType2:false,   //显示哪一种设备可燃气
        showType3:false,   //灭火瓶
        showType4:false,   //水压
        showType5:false,   //烟感
        showType6:false,   //液位
        showType7:false,   //水浸
        showType8:false,   //用传
        clientText:'',
        overflowText1:'',
        tableFormParams:{   //报警数据
          monitorId: '',
          type:'',
          currentPage: 1,
          dealType:[0,1,2],
          pageSize: 13,
          startTime: '',
          endTime: '',
        },
        infoType:'',
        tableFormParams1:{    //处理表单
          monitorId: '',
          type:'',
          currentPage: 1,
          dealType:[2,3,4,8],
          pageSize: 13,
          startTime: '',
          endTime: '',
        },
        overflowText:'',
        windowResize:null,
        mangerWidth:'',    //管理人员容器宽度
        tipClientWidth:'',
        tipScrollWidth:'',
      }
    },
    created() {
      this.detailId=sessionStorage.getItem('saveId');
      if(this.isAuth('common:interface')){
        this.getBasicInfo();
      }
    },
    computed:{
      getMap() {
        return this.$store.state.buildingId
      }
    },
    watch: {
      getMap (newV, oldV) { // status的变化，然后执行操作
        if(this.isAuth('common:interface')){
          this.getBasicInfo();//获取TAB设备类型
        }
      }
    },
    methods:{
      isShowTooltip(el){
        this.tipClientWidth=el.srcElement.clientWidth;
        this.tipScrollWidth=el.srcElement.scrollWidth;
      },
      changeText1(e){ //文字显示...
        this.overflowText1 = $(e.toElement)[0].offsetWidth;
        this.clientText=$(e.toElement)[0].parentNode.clientWidth;
      },
      isScroll(){
        this.$nextTick(()=>{
          let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
            cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
          if(sHeight>cHeight){
            document.getElementsByClassName('main')[0].style.marginRight=0;
            document.getElementsByClassName('table_info')[0].style.marginRight=0;
          }else {
            document.getElementsByClassName('main')[0].style.marginRight='20px';
            document.getElementsByClassName('table_info')[0].style.marginRight='20px';
          }
        });
      },
      returnBtn(){ //返回按钮;
        sessionStorage.setItem('returnType',1);//区分是否保留筛选条件历史记录
        this.$router.push({path:'/content/warningManger'});
      },
      routerIndex(){
        sessionStorage.setItem('returnType',1);//区分是否保留筛选条件历史记录
        this.$router.push({path:'/content/warningManger'});
      },
      changeText(e){ //文字显示...
        // this.overflowText = $(e.toElement)[0].scrollWidth;
        this.overflowText = e.srcElement.scrollWidth;
      },
      //获取基本信息
      getBasicInfo(){
        let params={
          monitorId:this.detailId
        };
        ajaxFuncJson('/alarmManager/getMonitorMessage',params).then(res=>{
          if(res.data.status==200){
            this.basicInfo=res.data.data;
            if(this.basicInfo.floorNum){
              if(String(this.basicInfo.floorNum).indexOf('-')!=-1){
                this.basicInfo.floorNum=String(this.basicInfo.floorNum).replace('-','B');
              }else {
                this.basicInfo.floorNum='L'+this.basicInfo.floorNum;
              }
            }else {
              this.basicInfo.floorNum='待标注'
            }
            this.infoType=res.data.data.type;
            if(this.basicInfo.deviceStatus==0){
              this.basicInfo.deviceStatus='启用';
            }else {
              this.basicInfo.deviceStatus='故障';
            }
            if(this.basicInfo.runStatus==1){    //true 1 告警  false 0 正常
              this.basicInfo.runStatus='告警';
            }else if(this.basicInfo.runStatus==2){
              this.basicInfo.runStatus='预警';
            }else{
              this.basicInfo.runStatus='正常';
            }
            if(this.basicInfo.manageName){
              this.basicInfo.managePeople=this.basicInfo.manageName.split(',').join(' | ');
              this.basicInfo.manageName=this.basicInfo.manageName.split(',').join('|').replace(/\|/g,'<span style="margin: 0 10px">|</span>')
            }
            if(this.basicInfo.connectStatus){
              this.basicInfo.connectStatus='离线';
            }else {
              this.basicInfo.connectStatus='在线';
            }
            if(this.basicInfo.enabled){
              this.basicInfo.enabled='禁用';
            }else {
              this.basicInfo.enabled='启用';
            }
            if(this.basicInfo.type==1){
              this.basicInfo.type='电气';
              this.showType1=true;
            }else if(this.basicInfo.type==2) {
              this.basicInfo.type='水压';
              this.showType4=true;
            }else if(this.basicInfo.type==3) {
              this.basicInfo.type='液位';
              this.showType6=true;
            }else if(this.basicInfo.type==4) {
              this.basicInfo.type='可燃气';
              this.showType2=true;
            }else if(this.basicInfo.type==5) {
              this.basicInfo.type='烟感';
              this.showType5=true;
            }else if(this.basicInfo.type==6){
              this.basicInfo.type='灭火器';
              this.showType3=true;
            }else if(this.basicInfo.type==7){
              this.basicInfo.type='水浸';
              this.showType7=true;
            }else if(this.basicInfo.type==8){
              this.basicInfo.type='用传';
              this.showType8=true;
            }
            this.getWarningTable();
            this.getAllFormData();
          }
        });
      },
      //获取处理表单查询
      getAllFormData(type){
        this.tableFormParams1.monitorId=this.detailId;
        this.tableFormParams1.type=this.infoType;
        ajaxFuncJson('/alarmManager/getDealFrom',this.tableFormParams1).then(res=>{
          if(res.data.status==200){
            this.tableData=res.data.data;
            if(this.tableData.length ==0){
                  this.changeData(2);
                  this.isActive = false;
                  this.warningData = true;
            }
            this.tableData.forEach((item,index)=>{
              if(this.tableData[index].dealPeople){
                this.tableData[index].dealPeople=item.dealPeople.join('、');
              }else{
                this.tableData[index].dealPeople='';
              }
              if(this.tableData[index].problem){
                this.tableData[index].problem=item.problem.join('、');
              }else{
                this.tableData[index].problem='';
              }
            });
            if(!type){
              if(res.data.data.length===0){
                this.total1=0
              }else {
                this.total1=res.data.data[0].count
              }
            }
            this.isScroll();
          }
        })
      },
      //点击报警处理跳转
      warningSet(){
        this.$router.push({path:'/content/editForm',query:{type:'new_add',deviceType:this.tableFormParams.type}}); //新增报警处理表单
      },
      //相除时防止浮点数值转化
      accDiv(arg1,arg2){
        var t1=0,t2=0,r1,r2;
        try{
          t1=arg1.toString().split(".")[1].length;
        }catch(e){}

        try{
          t2=arg2.toString().split(".")[1].length;
        }catch(e){}
          r1=Number(arg1.toString().replace(".",""));
          r2=Number(arg2.toString().replace(".",""));
          return (r1/r2)*Math.pow(10,t2-t1);
      },
      //获取告警数据
      getWarningTable(type){
        if(this.isAuth('common:interface')){
          this.tableFormParams.monitorId=this.detailId;
          this.tableFormParams.type=this.infoType;
          ajaxFuncJson('/alarmManager/getAlarmMessage',this.tableFormParams).then(res=>{
            if(res.data.status==200){
              this.warningTableData=res.data.data;
              if(this.infoType==2){    //水压
                this.warningTableData.forEach((a,b)=>{
                  this.warningTableData[b].rcv=this.accDiv(a.rcv,1000);
                  this.warningTableData[b].battery=this.accDiv(a.battery,100); //四期数据处理
                })
              }else if(this.infoType==3){   //液位
                this.warningTableData.forEach((a,b)=>{
                  this.warningTableData[b].rcv=this.accDiv(a.rcv,100);
                  this.warningTableData[b].battery=this.accDiv(a.battery,100);
                })
              }else if(this.infoType==6){   //灭火瓶
                this.warningTableData.forEach((a,b)=>{
                  this.warningTableData[b].battery=this.accDiv(a.battery,10);
                })
              }
              if(!type){
                if(res.data.data.length===0){
                  this.warningTableDataTotal=0
                }else {
                  this.warningTableDataTotal=res.data.data[0].count
                }
              }
            }
          });
        }
      },
      //告警消音
      warningSilence(){
        this.$confirm('确定发送消音指令吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal:false,
          closeOnPressEscape:false,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '发送成功!'
          });
        }).catch(() => {

        });
      },
      //告警数据分页
      handleCurrentChange(val){
          this.tableFormParams.currentPage=val;
          this.getWarningTable(1);
      },
      //表单分页
      handleCurrentChange1(val){
        this.tableFormParams1.currentPage=val;
        this.getAllFormData(1);
      },
      //切换表格
      changeData(a){
        // if(this.warningData){
        //   this.selectName1='处理表单';
        //   this.selectName2='报警数据';
        // }else {
        //   this.selectName1='报警数据';
        //   this.selectName2='处理表单';
        // }
        //   this.warningData=!this.warningData;
        if(a==1){
            this.warningData = false;
            this.isActive = true;
        }else if(a==2){
            this.warningData = true;
            this.isActive = false;
        }
      },
      //查看数据
      lookDetailData(row, column, event){
        sessionStorage.setItem('dealStatus',row.dealStatus);
        this.$router.push({path:'/content/searchForm',query:{id:row.id,deviceType:this.infoType}})
      },
      //查看数据
      lookDetailData1(row, column, event){
        if(row.dealStatus==1){
          sessionStorage.setItem('dealStatus',row.dealStatus);
          this.$router.push({path:'/content/searchForm',query:{id:row.alarmDealRecordId,deviceType:this.infoType,type:'warnData'}})
        }else if(row.dealStatus==2){
          this.$router.push({path:'/content/searchForm',query:{id:row.alarmDealRecordId,deviceType:this.infoType}})
        }
      }
    },
    mounted(){
      let that = this;
      that.windowResize= function () {
        let basicWidth=$('.main').width()-10;
        that.tableHeight= $('body').height()-81-$('.mainHead').outerHeight()-$('.main').outerHeight()-$('.table').outerHeight()-20;
        that.scrollHeight=$('body').height()-71-$('.mainHead').outerHeight();
        that.leftItemWidth=basicWidth*.25;
        that.mangerWidth=$('.main_left')[0].scrollWidth-that.leftItemWidth;
        that.isScroll();
      };
      that.windowResize();
      window.addEventListener("resize",that.windowResize);
    },
    destroyed(){
      let _this=this;
      window.removeEventListener("resize",_this.windowResize)
    }
  }
</script>
<style scoped>
  .main{
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
  }
  .table_info .mainHead > div > span{
    margin-right: 10px;
  }
  .table_info .mainHead .isActivClass{
    color: #198cff;
    font-weight: normal;
    font-size: 13px;
  }
  .special_color{
    color: #198cff;
  }
  .no_data{
    color: #666;
    font-size: 14px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no_data .no_tip{
    padding-top: 10px;
    text-align: center;
  }
  .hidden_address{
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    top:3px;
  }
  .has_user{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
  .router_link:hover{
    color:#198CFF;
    cursor: pointer;
  }
  .main .main_left{
    background: #fff;
    font-size: 14px;
    color: #282828;
    padding: 20px 20px 20px 40px;
    position: relative;
    height: 187px;
    margin-right: 10px;
  }
  .fixedScorll{
    height: 300px;
  }
  .main .main_right{
    margin-right: 0;
    width: 42%;
  }
  .main .left_btn{
    position: absolute;
    right: 20px;
    top:20px;
  }
  .main .main_left .left_item_info{
    display: flex;
    padding-bottom: 15px;
  }
  .main .main_left .left_item_info span{
    padding-left: 10px;
    line-height: 16px;
  }
  .main .main_left .left_item_info .device_type{
    padding-left: 0;
    display: inline-block;
    width: 73px;
  }
  .right_left_container{
    float: left;
  }
  .current_time{
    position: absolute;
    top:20px;
    right: 20px;
    font-size: 14px;
    color: #282828;
  }
  .img_container{
    width: 228px;
    height: 130px;
    margin-left: 20px;
  }
  .img_container img{
    width: 100%;
    height: auto;
  }
  .right_left_container .type_current{
    width: 120px;
    height: 60px;
    background: #F2F2F2;
    text-align: center;
    padding: 10px 0;
    margin-bottom: 10px;
  }
  .table_info{
    margin-right: 20px;
  }
  .el-main .table{
    margin-top: 10px;
    border-bottom: 1px solid rgba(228, 228, 228, 1);
    padding: 5px 20px 5px 10px;
    background-color: #fafafa;
  }
  .table_data{
    padding: 10px 10px 20px 10px ;
    background: #fff;
    margin-bottom: 10px;
  }
  .table_data .el-table__header-wrapper th{
    color: #fff!important;
    background: #062783!important;
  }
  .page_control{
    text-align: right;
    margin-top: 15px;
  }
  .page_control .el-input__inner{
    width: 46px!important;
  }
</style>



// WEBPACK FOOTER //
// src/page/warningManger/warnDetail.vue